/*=========================================================================================
  File Name: moduleCalendarActions.js
  Description: Calendar Module Actions
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/

import axios from '@/axios.js';
import defaultAxios from 'axios';
import constants from '@/constants.js';
import { logout } from '@/services/auth.service';

export default {

  async authenticateUser({ commit }, userDetails) {
    try {
      const payload = {
        strategy: 'local',
        email: userDetails.email,
        otp: userDetails.password,
        userType: userDetails.userType
      };
      const authenticationObj = await axios.post(`${constants.loginServiceUrl}/verify-otp`, payload);
      if(authenticationObj.data.data.validOtp) {
        axios.defaults.headers.common['Authorization'] = `Bearer ${authenticationObj.data.data.token}`;
        localStorage.setItem('accessToken', authenticationObj.data.data.token);
        localStorage.setItem('user', JSON.stringify(authenticationObj.data.data.user));

        commit('SET_USER', authenticationObj.data.data.user);
        commit('SET_ACCESS_TOKEN', authenticationObj.data.data.token);
        commit('SET_LOGGEDIN_STATE', true);

        return authenticationObj;
      } else {
        throw new Error('Unauthorized');
      }
    } catch (error) {
      throw error;
    }
  },

  async microsoftAuth({ commit }, userDetails) {
    try {
      axios.defaults.headers.common['Authorization'] = `Bearer ${userDetails.accessToken}`;
      localStorage.setItem('accessToken', userDetails.accessToken);
      localStorage.setItem('user', JSON.stringify(userDetails.user));

      commit('SET_USER', userDetails.user);
      commit('SET_ACCESS_TOKEN', userDetails.accessToken);
      // commit('SET_BEARER', authenticationObj.data.accessToken);
      commit('SET_LOGGEDIN_STATE', true);

      return userDetails;
    } catch (error) {
      throw error;
    }
  },

  /*async fetchUser({ commit }, userDetails) {
    try {
      axios.defaults.headers.common['Authorization'] = `Bearer ${userDetails.accessToken}`;
      const fetchedUser = await axios.get(`${constants.apiHost}/users/${userDetails.userId}`);
      commit('SET_USER', fetchedUser.data);
      localStorage.setItem('accessToken', userDetails.accessToken);
      // Update user details
      // commit('UPDATE_USER_INFO', fetchedUser.data.userData, { root: true });
      // Set bearer token in axios
      commit('SET_BEARER', userDetails.accessToken);
      return fetchedUser;
    } catch (error) {
        throw error;
    }
  },*/

  async createUser({ commit }, userDetails) {
    try {
      const payload = {
        email: userDetails.email,
        password: userDetails.password,
      }
      const newUser = await axios.post(`${constants.apiHost}/users`, payload);
      return newUser;
    } catch (error) {
        throw error;
    }
  },

  /*async sendMeAMagicLink({ commit }, userDetails) {
    try {
      const authenticatedUserData = await authenticateUser(userDetails);
      const payload = {
        userDetails,
        authenticatedUserData
      }
      const magicLinkData = await axios.post(`${constants.apiHost}/mailer`, { payload });
      return magicLinkData;
    } catch (error) {
        throw error;
    }
  },*/

  async sendMeOTP({ commit }, userDetails) {
    try {
      const payload = {
        email: userDetails.email,
        firstName: userDetails.firstName ? userDetails.firstName : '',
        lastName: userDetails.lastName ? userDetails.lastName : '',
        password: userDetails.password,
        mailType: 'mail-otp',
        userSource: userDetails.userSource,
        breakMail: userDetails.breakMail
      };
      const otpData = await axios.post(`${constants.loginServiceUrl}/get-otp`, payload);
      return otpData;
    } catch (error) {
      throw error;
    }
  },

  // fetchUsers (context, userId) {
  //   return new Promise((resolve, reject) => {
  //     axios.get(`/api/user-management/users/${userId}`)
  //       .then((response) => {
  //         resolve(response)
  //       })
  //       .catch((error) => { reject(error) })
  //   })
  // },

  // removeRecord({ commit }, userId) {
  //   return new Promise((resolve, reject) => {
  //     axios.delete(`/api/user-management/users/${userId}`)
  //       .then((response) => {
  //         commit('REMOVE_RECORD', userId)
  //         resolve(response)
  //       })
  //       .catch((error) => { reject(error) })
  //   })
  // }

  logout({ commit }) {
    logout();
    axios.defaults.headers.common['Authorization'] = '';
  },

  async decryptInvitePhrase({ commit }, { invitePhrase }) {
    try {
      const inviteData = await defaultAxios.post(`${constants.loginServiceUrl}/invite/decrypt`, { invitePhrase });
      return inviteData.data;
    } catch (err) {
      throw err;
    }
  },

  async sendMeMagicLink({ commit }, userDetails) {
    try {
      const response = await axios.post(`${constants.apiHost}/magic-link`, userDetails);
      return response;
    } catch (error) {
      throw error;
    }
  },

  async generateMagicLink({ commit }, userDetails) {
    try {
      const inviteData = await defaultAxios.post(`${constants.loginServiceUrl}/invite/encrypt`, userDetails);
      return inviteData.data;
    } catch (error) {
      throw error;
    }
  },

  async magicLinkGeneration({ commit }, userDetails) {
    try {
      const inviteData = await defaultAxios.post(`${constants.loginServiceUrl}/magic-link/generate`, userDetails);
      return inviteData.data;
    } catch (error) {
      throw error;
    }
  },
}
